var _desc;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 798.98096,
    viewBox: "0 0 64 63.918477",
    enableBackground: "new 0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "swatch5"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop5"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, "Road") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc1"
  }, "Created with Sketch.")), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fill: "none",
    stroke: "#6b6c6e",
    strokeWidth: 2.01293,
    d: "m 62.993534,60.88564 c 0,1.114503 -0.899813,2.026369 -1.999583,2.026369 H 3.0060478 c -1.0997706,0 -1.9995828,-0.911866 -1.9995828,-2.026369 L 11.004379,3.032833 c 0,-1.1145024 0.899812,-2.026368 1.999583,-2.026368 h 37.992074 c 1.099771,0 1.999583,0.9118656 1.999583,2.026368 l 4.407509,25.503996 z",
    style: {
      display: "inline",
      stroke: "#ffffff",
      strokeLinecap: "butt",
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    style: {
      fill: "#656565",
      fillOpacity: 0,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    transform: "translate(-5.4180908e-7,-0.08152574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Road",
    transform: "translate(1,2)",
    style: {
      fill: "#656565",
      fillOpacity: 0,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("line", {
    id: "Rectangle-path_7_",
    fill: "none",
    stroke: "#6B6C6E",
    strokeWidth: 2,
    x1: 31,
    y1: 10.1,
    x2: 31,
    y2: 4,
    style: {
      fill: "#656565",
      fillOpacity: 0,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Rectangle-path_6_",
    fill: "none",
    stroke: "#6B6C6E",
    strokeWidth: 2,
    x1: 31,
    y1: 23.9,
    x2: 31,
    y2: 17,
    style: {
      fill: "#656565",
      fillOpacity: 0,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Rectangle-path_5_",
    fill: "none",
    stroke: "#6B6C6E",
    strokeWidth: 2,
    x1: 31,
    y1: 39,
    x2: 31,
    y2: 31,
    style: {
      fill: "#656565",
      fillOpacity: 0,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Rectangle-path_4_",
    fill: "none",
    stroke: "#6B6C6E",
    strokeWidth: 2,
    x1: 31,
    y1: 57.099998,
    x2: 31,
    y2: 46,
    style: {
      fill: "#656565",
      fillOpacity: 0,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.999996,
      strokeDasharray: "none",
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    id: "g1",
    transform: "matrix(0.18880067,0,0,0.18880067,10.784923,6.1533253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 232.47656,215.51563 -40.67773,-40.67774 a 96.10791,96.10791 0 1 0 -16.97168,16.96973 l 40.67871,40.67871 a 12.0001,12.0001 0 1 0 16.9707,-16.9707 z M 43.99707,116 a 72,72 0 1 1 72,72 72.08124,72.08124 0 0 1 -72,-72 z",
    id: "path1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.999996,
      strokeDasharray: "none",
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadAnalysis);
export default __webpack_public_path__ + "static/media/road-analysis.caa751d2d0f9b6a52fbc3c6578dcb183.svg";
export { ForwardRef as ReactComponent };